import { Table } from "antd";
import { InvoiceItem } from "../../repository/data.default";
import { invoiceItemsViewColumns, TableFooter } from "./InvoiceTable.default";

export interface InvoiceTableProps {
  invoiceItems: InvoiceItem[];
}

function InvoiceTable(props: InvoiceTableProps) {
  return (
    <Table
      bordered
      pagination={false}
      columns={invoiceItemsViewColumns}
      dataSource={props.invoiceItems.map((item) => ({
        ...item,
        key: item.uid,
      }))}
      summary={() => <TableFooter invoiceItems={props.invoiceItems} />}
    />
  );
}

export default InvoiceTable;
